import memoize from 'memoizee';
import type { TestContext, TestFunction } from 'yup';

import { validatePassport } from 'shared/api/daData';

const validatePassportCached = memoize((passport: string) => validatePassport(passport), {
  promise: true,
  maxAge: 1000 * 60, // 1 минута
});

const errorMessage = 'Укажите корректный номер';

export const isActivePassport: TestFunction = async (value, testContext) => {
  const context = testContext.parent ? testContext : (testContext.options.context as TestContext);
  const passportSN = String(value).replace(/\D/g, '');

  if (passportSN.length !== 10) {
    return context.createError({ path: context.path, message: errorMessage });
  }

  try {
    const isValid = await validatePassportCached(passportSN);

    return Boolean(isValid) || context.createError({ path: context.path, message: errorMessage });
  } catch {
    return context.createError({ path: context.path, message: errorMessage });
  }
};
